import { PrismTooltipHeader } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, not } from 'ember-truth-helpers';
import GeneralTooltipsTooltipRatesBodySection from 'lumen/components/general/tooltips/tooltip-rates-body-section';
import GeneralTooltipsTooltipRatesEvolutionHeaderSection from 'lumen/components/general/tooltips/tooltip-rates-evolution-header-section';
import GeneralTooltipsTooltipRatesGeneric from 'lumen/components/general/tooltips/tooltip-rates-generic';
import GeneralTooltipsTooltipRatesHeaderSection from 'lumen/components/general/tooltips/tooltip-rates-header-section';

export default class GeneralTooltipsTooltipRatesCalendar extends GeneralTooltipsTooltipRatesGeneric {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rates() {
    return this.args.period?.rates;
  }

  <template>
    {{! @glint-nocheck }}
    <PrismTooltipHeader>
      <span>
        {{#if this.currentDate}}
          {{this.currentDate}}
        {{/if}}
        {{#if
          (and
            (and this.isFutureDate (not @hideUpdateTime)) this.updateTimeDate
          )
        }}
          &nbsp;({{t "general.updated"}}
          {{this.updateTimeDate}})&nbsp;
        {{/if}}
      </span>
    </PrismTooltipHeader>
    {{#if @isRatesEvolution}}
      <GeneralTooltipsTooltipRatesEvolutionHeaderSection
        @formattedMedian={{this.formattedMedian}}
        @period={{@periodForEvolutionTooltipHeader}}
      />
    {{else}}
      <GeneralTooltipsTooltipRatesHeaderSection
        @formattedMedian={{this.formattedMedian}}
        @period={{@period}}
      />
    {{/if}}
    <GeneralTooltipsTooltipRatesBodySection
      @compRatesArray={{this.compRatesArray}}
      @competitorRatesWithDifferentLos={{this.competitorRatesWithDifferentLos}}
      @isLastSection={{true}}
      @otaId={{@otaId}}
      @shortTermRentalRate={{this.shortTermRentalRate}}
    />
  </template>
}
